export default class AuthedStore {
    getHeaders() {
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + localStorage.getItem('access_token'),
        };
    }
}



// WEBPACK FOOTER //
// ./src/stores/AuthedStore.ts